import { DateAndTimeInterface } from "."

export const headerDateTable: string[] = [ "", "Dia", "Hr. Início", "Intervalo", "Retorno", "Fim", '']


interface inputsInterface {
    name: keyof DateAndTimeInterface 
}

export const inputs: inputsInterface[] = [
    {
        name: 'initHr',
    },
    {
        name: 'interval',
    },
    {
        name: 'return',
    },
    {
        name: 'end',
    }
]



export const mock = [
    {
        id: 2,
        active: true,
        day: "Segunda-feira",
        initHr: "08:00",
        interval: '12:00',
        return:  "13:00",
        end: "17:00"
    },
    {
        id: 3,
        active: true,
        day: "Terça-feira",
        initHr: "08:00",
        interval: '12:00',
        return:  "13:00",
        end: "17:00"
    },
    {
        id: 4,
        active: true,
        day: "Quarta-feira",
        initHr: "08:00",
        interval: '12:00',
        return:  "13:00",
        end: "17:00"
    },
    {
        id: 5,
        active: false,
        day: "Quinta-feira",
        initHr: "08:00",
        interval: '12:00',
        return:  "13:00",
        end: "17:00"
    },
    {
        id: 6,
        active: true,
        day: "Sexta-feira",
        initHr: "08:00",
        interval: '12:00',
        return:  "13:00",
        end: "17:00"
    },
    {
        id: 7,
        active: true,
        day: "Sábado",
        initHr: "08:00",
        interval: '',
        return:  "",
        end: "12:00"
    },
    {
        id: 1,
        active: true,
        day: "Domingo",
        initHr: "08:00",
        interval: '12:00',
        return:  "13:00",
        end: "17:00"
    }
]